import React, { useEffect } from "react";
import L from "leaflet";
import { useMap } from "react-leaflet";
const LeafletGeocoder = ({ setPosition }) => {
  const map = useMap();
  useEffect(() => {
    L.Control.geocoder({
      defaultMarkGeocode: false,
      showResultIcons:true,
      showUniqueResult:true
    })
      .on("markgeocode", function (e) {
        let latlng = e.geocode.center;
        setPosition(latlng);
        // L.marker(latlng).addTo(map).bindPopup(e.geocode.name).openPopup();
        // map.fitBounds(e.geocode.bbox);
      })
      .addTo(map);
  }, []);
  return null;
};

export default LeafletGeocoder;
